import { render, staticRenderFns } from "./DeliveryRegionsSelect.vue?vue&type=template&id=71f34b52&"
import script from "./DeliveryRegionsSelect.vue?vue&type=script&lang=js&"
export * from "./DeliveryRegionsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports